import { axiosClient } from './axiosClient';
import { APIUrls } from '../constant/constant';

const { DEIVCE_TROUBLE_SHOOTING } = APIUrls;

/**
 * Shelly API Module
 * 
 * This module handles all API calls related to Shelly device control:
 * - Device restart , on/off operations
 * - Device history
 * Used by: src/pages/deviceTrouble/DeviceTrouble.js
 */

/**
 * Restart a Shelly device switch
 * @param {Object} payload - The payload object containing deviceMac and triggeredby
 * @returns {Promise<Object>} API response
 */
export async function rebootDeviceApi(payload) {
  try {
    const response = await axiosClient.post(DEIVCE_TROUBLE_SHOOTING.REBOOT, payload);
    return response.data;
  } catch (error) {
    console.error('Error restarting device:', error);
    throw error;
  }
}

/**
 * Turn on a Shelly device switch
 * @param {Object} payload - The payload object containing deviceMac and triggeredby
 * @returns {Promise<Object>} API response
 */
export async function turnOnDeviceApi(payload) {
  try {
    const response = await axiosClient.post(DEIVCE_TROUBLE_SHOOTING.TURN_ON, payload);
    return response.data;
  } catch (error) {
    console.error('Error turning on device:', error);
    throw error;
  }
}

/**
 * Turn off a Shelly device switch
 * @param {Object} payload - The payload object containing deviceMac and triggeredby
 * @returns {Promise<Object>} API response
 */
export async function turnOffDeviceApi(payload) {
  try {
    const response = await axiosClient.post(DEIVCE_TROUBLE_SHOOTING.TURN_OFF, payload);
    return response.data;
  } catch (error) {
    console.error('Error turning off device:', error);
    throw error;
  }
}

/**
 * Get device history by MAC address
 * @param {string} deviceMac - The MAC address of the device
 * @returns {Promise<Object>} API response containing history data
 */
export async function getDeviceHistoryApi(deviceMac) {
  try {
    const response = await axiosClient.get(`${DEIVCE_TROUBLE_SHOOTING.GET_HISTORY}/${deviceMac}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching device history:', error);
    throw error;
  }
}
